// libraries
import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

// styles
import styles from "./styles.module.scss";

// assets
import startsImg from "../../../assets/images/create-event/starts.svg";
import virtualImg from "../../../assets/images/create-event/virtual.svg";
import linkImg from "../../../assets/images/create-event/link.svg";
import categoryImg from "../../../assets/images/create-event/category.svg";
import locationImg from "../../../assets/images/create-event/location.svg";
import durationImg from "../../../assets/images/create-event/duration.svg";
import timezoneImg from "../../../assets/images/create-event/timezone.svg";
import priceImg from "../../../assets/images/create-event/price.svg";
import reoccurringImg from "../../../assets/images/create-event/reoccuring.svg";
import ThreeDotsDark from "src/assets/icons/three-dots-dark.svg";

// components
import Wrap from "./Widgets/Wrap/Wrap";
import Category from "./Widgets/Category/Category";
import Location from "./Widgets/Location/Location";
import DateTimePicker from "./Widgets/DateTimePicker/DateTimePicker";

// api
import { createEvent, getUserEvents } from "../api";

// context
import UserContext from "src/context/User";

const Info = ({ formData, setFormData, setMyEventData }) => {
  const { user } = useContext(UserContext);

  // states
  const [showModal, setShowModal] = useState(null);
  const [loading, setLoading] = useState(false);

  // history
  const history = useHistory();

  // toogle modal
  const toggleModal = (_value) => {
    setShowModal(_value);
  };

  const handleClick = () => {
    setLoading(true);

    let data = {
      ...formData,
      accessToken: user.accessToken,
      userId: user.userId,
    };

    createEvent(data)
      .then((res) => {
        console.log(res);
        if (res.data.Status) {
          userEvents(res.data.Results.eventId);
        } else {
          setLoading(false);
          toast.error(res.data.ErrorMessage);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  };

  const userEvents = (_id) => {
    let data = {
      userId: user?.userId,
      accessToken: user?.accessToken,
    };

    getUserEvents(data)
      .then((res) => {
        setLoading(false);
        if (res.data.Status) {
          let event = res.data.Results.find((item) => item.eventId === _id);
          if (event) {
            console.log(event);
            setMyEventData(event);
          } else {
            toast.error("new event not found");
          }
        } else {
          toast.error(res.data.ErrorMessage);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  };

  return (
    <div className={styles.info}>
      <Wrap
        icon={<img src={startsImg} alt="starts" style={{ height: "32px" }} />}
        label="Select Date"
        value={
          formData.eventStartDate === ""
            ? ""
            : `${formData.eventStartDate} - ${formData.eventEndDate}`
        }
        placeholder="Select start & end date"
        toggleModal={toggleModal}
      >
        {showModal === "starts" && (
          <DateTimePicker
            formData={formData}
            setFormData={setFormData}
            isDate
            toggleModal={toggleModal}
          />
        )}
      </Wrap>
      {/* <>
      <Wrap
        icon={<img src={virtualImg} alt="virtuak" style={{ height: "20px" }} />}
        label="Virtual"
        value={virtual ? "Yes" : "No"}
        toggleModal={toggleModal}
      >
        {showModal === "virtual" && (
          <Virtual setVirtual={setVirtual} toggleModal={toggleModal} />
        )}
      </Wrap>
      {virtual && (
        <Wrap
          icon={
            <img src={linkImg} alt="virtual-link" style={{ height: "26px" }} />
          }
          label="Virtual Link"
          value={link}
          placeholder="link"
          toggleModal={toggleModal}
        >
          {showModal === "link" && (
            <Link link={link} setLink={setLink} toggleModal={toggleModal} />
          )}
        </Wrap>
      )}
      </> */}
      <Wrap
        icon={
          <img src={categoryImg} alt="category" style={{ height: "29px" }} />
        }
        label="Category"
        value={formData.eventCategory?.name || ""}
        placeholder="Select category"
        toggleModal={toggleModal}
      >
        {showModal === "category" && (
          <Category formData={formData} setFormData={setFormData} />
        )}
      </Wrap>
      <Wrap
        icon={
          <img src={locationImg} alt="location" style={{ height: "28px" }} />
        }
        label="Location"
        value={formData.eventLocation?.name || ""}
        placeholder="Select location"
        // locations={["Ahmedpur town", "Yazman, Mandi 123", "Bahawalpur, 23"]}
        toggleModal={toggleModal}
      >
        {showModal === "location" && (
          <Location
            formData={formData}
            setFormData={setFormData}
            toggleModal={toggleModal}
          />
        )}
      </Wrap>
      <Wrap
        icon={
          <img src={durationImg} alt="duration" style={{ height: "28px" }} />
        }
        label="Select Time"
        value={
          formData.eventStartTime === ""
            ? ""
            : `${formData.eventStartTime} - ${formData.eventEndTime}`
        }
        placeholder="Select start & end time"
        toggleModal={toggleModal}
      >
        {showModal === "duration" && (
          <DateTimePicker
            formData={formData}
            setFormData={setFormData}
            toggleModal={toggleModal}
          />
        )}
      </Wrap>
      {/* <Wrap
        icon={
          <img src={timezoneImg} alt="timezone" style={{ height: "32px" }} />
        }
        label="Timezone"
        value={timezone}
        placeholder="Select timezone"
        toggleModal={toggleModal}
      >
        {showModal === "timezone" && (
          <Timezone
            timezone={timezone}
            setTimezone={setTimezone}
            timezoneSearch={timezoneSearch}
            setTimezoneSearch={setTimezoneSearch}
            toggleModal={toggleModal}
          />
        )}
      </Wrap> */}
      {/* <Wrap
        icon={
          <img
            src={reoccurringImg}
            alt="reoccurring"
            style={{ height: "32px" }}
          />
        }
        label="Reoccurring Event"
        value={reoccurring}
        toggleModal={toggleModal}
      >
        {showModal === "reoccurring" && <Reoccurring />}
      </Wrap> */}
      {/* <Wrap
        icon={<img src={priceImg} alt="price" style={{ height: "31.5px" }} />}
        label="Price"
        value={`$${price}`}
        placeholder="Select price"
        toggleModal={toggleModal}
      >
        {showModal === "price" && (
          <Price price={price} setPrice={setPrice} toggleModal={toggleModal} />
        )}
      </Wrap> */}
      <div className={styles.btns}>
        {!loading ? (
          <>
            <button onClick={() => history.push("/")}>Cancel</button>
            <button onClick={handleClick}>Create</button>
          </>
        ) : (
          <img src={ThreeDotsDark} alt="loading" />
        )}
      </div>
    </div>
  );
};

export default Info;
